module.exports = __webpack_public_path__ + "img/9.071dc01f.png";